import styles from './WeekPlanCard.module.css';

const WeekPlanDay = ({ day }) => (
    <li className={day.isToday ? styles.today : undefined} aria-current={day.isToday ? 'date' : undefined}>
        <div className={styles.day}>
            <b>{day.label.split(' ')[0]}</b>
            {day.label.split(' ').slice(1).join(' ')}
        </div>
        <div className={styles.sessions}>
            {day.sessions.length === 0 && <span className={styles.rest}>Rest day</span>}
            {day.sessions.map(s => (
                <div className={styles.sess} key={s.id}>
                    <span className={styles.group}>{s.groupName}</span>
                    <span className={styles.title}>
                        {s.title}
                        {s.subtitle && <small>{s.subtitle}</small>}
                    </span>
                    {s.km && <span className={styles.meta}>{s.km} km</span>}
                    <span className={styles.meta}>{s.time}</span>
                    {s.completion && (
                        <span className={styles.pill} title="Athletes who completed this session">
                            {s.completion.completed}/{s.completion.total}
                        </span>
                    )}
                </div>
            ))}
        </div>
    </li>
);

export default WeekPlanDay;
